<template>
  <div id="csContainer">
    <el-button class="getModel" size="small" type="primary" @click="getModel()" >高亮模型</el-button>
  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'getModel',
        data(){
            return{
                isShow: false,
                viewer: null
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                let vm = util.getViewer("csContainer");
                this.viewer = vm;
            },
            getModel(){
              let viewer = this.viewer;
              // var position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);
              // var url = 'models/car.glb';
              // var heading = Cesium.Math.toRadians(135);
              // var pitch = 0;
              // var roll = 0;
              // var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
              // var orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
              // var entity = viewer.entities.add({
              //   name : url,
              //   position : position,
              //   orientation : orientation,
              //   model : {
              //     uri : url,
              //     minimumPixelSize : 1,
              //     maximumScale : 200,
              //     scale:1
              //   }
              // });
              //
              // viewer.trackedEntity = entity;
              // let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
              // handler.setInputAction(function (movement) {
              //   var pickedObject = viewer.scene.pick(movement.endPosition);
              //   if(Cesium.defined(pickedObject)&&(pickedObject.id === entity)){
              //     // entity.model.scale = 1.5;
              //     entity.model.color =  Cesium.Color.WHITE;
              //     entity.model.colorBlendMode = Cesium.ColorBlendMode['MIX'];
              //   }else{
              //     entity.model.color =  null;
              //     entity.model.colorBlendMode = Cesium.ColorBlendMode['HIGHLIGHT'];
              //   }
              // },Cesium.ScreenSpaceEventType.MOUSE_MOVE);
// 这里
              let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 0.0));

              let model = viewer.scene.primitives.add(Cesium.Model.fromGltf({
                name: 'car',
                id: 'ab',
                url : "/demo/static/data/models/car.glb",
                modelMatrix : modelMatrix,
                scale : 1,

                // debugWireframe:true

                // color: Cesium.Color.BLUE,
                // colorBlendMode:Cesium.ColorBlendMode['MIX'],
              }));

              viewer.camera.setView({
                destination : Cesium.Cartesian3.fromDegrees(-75.62898254394531, 40.02804946899414, 20.0),
                orientation : {
                  heading : Cesium.Math.toRadians(-35),
                  pitch : Cesium.Math.toRadians(-95),
                  roll : 0.0
                }
              });


              let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
              handler.setInputAction(function (movement) {
                var pickedObject = viewer.scene.pick(movement.endPosition);
                if(Cesium.defined(pickedObject)&&(pickedObject.id === model.id)){
                  // entity.model.scale = 1.5;
                  model.color =  Cesium.Color.WHITE;
                  model.colorBlendMode = Cesium.ColorBlendMode['MIX'];
                }else{
                  model.colorBlendMode = Cesium.ColorBlendMode['HIGHLIGHT'];
                }
              },Cesium.ScreenSpaceEventType.MOUSE_MOVE);
            }
        }
    }
</script>
<style scoped>
  .getModel {
    position: absolute;
    margin-left: 25px;
    margin-top:7px;
    z-index: 999;
  }

  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
